import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { fetchQuery } from '@sequencehq/api'
import { useCallback } from 'react'
import invariant from 'tiny-invariant'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

export type v1ApiIntegration = Dashboardv20240509Api.GetIntegrations.Integration
type UseLoadIntegrations = () => () => Promise<{
  integrations: v1ApiIntegration[]
}>

export const useLoadIntegrations: UseLoadIntegrations = () => {
  const load = useCallback(async () => {
    const integrationsResponse = await fetchQuery(
      apiQueryClient,
      dashboardv20240509Client.getIntegrations,
      undefined,
      { staleTime: 10 * MINUTES }
    )

    const integrations = integrationsResponse?.items

    invariant(integrations, 'Integrations not found')

    return {
      integrations
    }
  }, [])

  return load
}
